import { SphereBufferGeometry } from 'three';

const geom = new SphereBufferGeometry(1, 16, 12);

export default function useUnitSphereGeometry(): SphereBufferGeometry
{
  return geom;
}